import { render, staticRenderFns } from "./Gym.vue?vue&type=template&id=06dc090e"
import script from "./Gym.vue?vue&type=script&lang=js"
export * from "./Gym.vue?vue&type=script&lang=js"
import style0 from "./Gym.vue?vue&type=style&index=0&id=06dc090e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports